import React from 'react';
import { Box, Stack, UnstyledButton, Text, Flex, Badge } from '@mantine/core';
import { ActiveFilter } from '../../types';

export interface ChildFilterItem {
  id: string;
  label: string;
  active: boolean;
  filterCount: number;
}

export interface ChildFiltersDropdownProps {
  searchInput: React.ReactNode;
  childFilters: ChildFilterItem[];
  middlePanelSearch: string;
  handleChildFilterSelect: (childFilterId: string) => void;
  localActiveFilters?: ActiveFilter[];
}

const ChildFiltersDropdown: React.FC<ChildFiltersDropdownProps> = ({
  searchInput,
  childFilters,
  middlePanelSearch,
  handleChildFilterSelect,
  localActiveFilters = [],
}) => {
  const hasActiveFilter = (childFilterId: string): boolean => {
    
    return localActiveFilters.some((filter) => filter.name === childFilterId);
  };

  return (
    <Box
      mt={7}
      pl={13}
    >
      {/* {searchInput} */}
      <Stack spacing={4}>
        {childFilters
          .filter(
            (child) =>
              !middlePanelSearch ||
            child.label.toLowerCase().includes(middlePanelSearch.toLowerCase())
          )
          .map((childFilter) => (
            <UnstyledButton
              key={childFilter.id}
              onClick={() => handleChildFilterSelect(childFilter.id)}
              className={`filter-category-button filter-child-button ${childFilter.active ? 'active' : ''}`}
            >
              <Text className="ellipsis-text" title={childFilter.label}>
                {childFilter.label}
              </Text>
              {hasActiveFilter(childFilter.id) && (
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#4f46e5',
                    flexShrink: 0,
                  }}
                />
              )}
            </UnstyledButton>
          ))}
      </Stack>
    </Box>
  );
};

export default ChildFiltersDropdown;